import { gql } from '@apollo/client'
import { CUSTOM_FIELD_ENTITY_GRAPHQL_TYPES } from '../models/custom-fields'
import { GqlCustomField } from './sale_create'

export interface SaleUpdateErrorMsg {
  field: SaleUpdateErrorMsgField
  message: string
}

enum SaleUpdateErrorMsgField {
  CUSTOMER = 'CUSTOMER',
}

export interface SaleUpdateActionInput {
  saleID: string
  saleUpdateCustomer?: SaleUpdateCustomer
  saleUpdateNote?: SaleUpdateNote
}

export interface SaleUpdateCustomer {
  customerID: string | null
}

export interface SaleUpdateNote {
  note: string
}

export interface SaleUpdateResponse {
  success: boolean
  errors?: SaleUpdateErrorMsg[]
}

export const UpdateSale = gql`
  mutation UpdateSaleMutation($input: SaleUpdateActionInput!) {
    saleUpdateActions(input: $input) {
      success
      errors {
        field
        message
      }
    }
  }
`

export interface SetCustomFieldValueInput {
  entity: CUSTOM_FIELD_ENTITY_GRAPHQL_TYPES
  entityID: string
  values: GqlCustomField
}

export const CustomFieldMutation = gql`
  mutation SetCustomFieldValues(
    $entityID: ID!
    $entity: CustomFieldEntity!
    $values: [CustomFieldValueInput!]!
  ) {
    setCustomFieldValues(
      entity: $entity
      entityId: $entityID
      values: $values
    ) {
      name
    }
  }
`
